module.exports = __webpack_public_path__ + "48a82d1313780e3d8958cd6d6bbe344a.png";


//////////////////
// WEBPACK FOOTER
// ../assets/tripitty-profile.png
// module id = 525
// module chunks = 0